/* ============================================================
   OSMANLI DOĞAL TAŞ — Doğum Haritası hesap motoru
   Saf JavaScript, kütüphanesiz. Kaynak: Jean Meeus, "Astronomical Algorithms".

   Doğruluk hedefi (burç/ev belirlemek için fazlasıyla yeterli):
     Güneş    ±0,01°   ·  Ay ±0,3°
     Gezegen  ±0,5°    ·  Yükselen ±0,2° (doğum saati doğruysa)
   ============================================================ */
(function (global) {
  'use strict';

  var D2R = Math.PI / 180, R2D = 180 / Math.PI;
  function sin(d) { return Math.sin(d * D2R); }
  function cos(d) { return Math.cos(d * D2R); }
  function tan(d) { return Math.tan(d * D2R); }
  function norm(d) { d = d % 360; return d < 0 ? d + 360 : d; }

  /* ---------------------------------------------- Julian Day (UT) */
  function julianDay(y, m, d, saatUT) {
    if (m <= 2) { y -= 1; m += 12; }
    var A = Math.floor(y / 100);
    var B = 2 - A + Math.floor(A / 4);          // Gregoryen takvim
    return Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (m + 1))
         + d + B - 1524.5 + saatUT / 24;
  }

  /* ---------------------------------------------- Güneş (Meeus 25) */
  function gunes(T) {
    var L0 = 280.46646 + 36000.76983 * T + 0.0003032 * T * T;
    var M  = 357.52911 + 35999.05029 * T - 0.0001537 * T * T;
    var C  = (1.914602 - 0.004817 * T - 0.000014 * T * T) * sin(M)
           + (0.019993 - 0.000101 * T) * sin(2 * M)
           + 0.000289 * sin(3 * M);
    return norm(L0 + C);                        // gerçek ekliptik boylam
  }

  /* ---------------------------------------------- Ay (Meeus 47, ana terimler) */
  function ay(T) {
    var Lp = 218.3164477 + 481267.88123421 * T - 0.0015786 * T * T;
    var D  = 297.8501921 + 445267.1114034 * T - 0.0018819 * T * T;
    var M  = 357.5291092 + 35999.0502909 * T - 0.0001536 * T * T;
    var Mp = 134.9633964 + 477198.8675055 * T + 0.0087414 * T * T;
    var F  =  93.2720950 + 483202.0175233 * T - 0.0036539 * T * T;

    var l = 6.288774 * sin(Mp)
          + 1.274027 * sin(2 * D - Mp)
          + 0.658314 * sin(2 * D)
          + 0.213618 * sin(2 * Mp)
          - 0.185116 * sin(M)
          - 0.114332 * sin(2 * F)
          + 0.058793 * sin(2 * D - 2 * Mp)
          + 0.057066 * sin(2 * D - M - Mp)
          + 0.053322 * sin(2 * D + Mp)
          + 0.045758 * sin(2 * D - M)
          - 0.040923 * sin(M - Mp)
          - 0.034720 * sin(D)
          - 0.030383 * sin(M + Mp)
          + 0.015327 * sin(2 * D - 2 * F)
          - 0.012528 * sin(Mp + 2 * F)
          + 0.010980 * sin(Mp - 2 * F)
          + 0.010675 * sin(4 * D - Mp)
          + 0.010034 * sin(3 * Mp)
          + 0.008548 * sin(4 * D - 2 * Mp)
          - 0.007888 * sin(2 * D + M - Mp)
          - 0.006766 * sin(2 * D + M)
          - 0.005163 * sin(D - Mp)
          + 0.004987 * sin(D + M)
          + 0.004036 * sin(2 * D - M + Mp)
          + 0.003994 * sin(2 * D + 2 * Mp)
          + 0.003861 * sin(4 * D)
          + 0.003665 * sin(2 * D - 3 * Mp);
    return norm(Lp + l);
  }

  /* ---------------------------------------------- Gezegenler
     Yörünge elemanları (J2000, yüzyıl başına değişim) + Kepler çözümü.
     Kaynak: NASA/JPL "Keplerian Elements for Approximate Positions".      */
  var GEZ = {
    merkur: { a:[0.38709927, 0.00000037], e:[0.20563593, 0.00001906], i:[7.00497902,-0.00594749],
              L:[252.25032350,149472.67411175], w:[77.45779628, 0.16047689], O:[48.33076593,-0.12534081] },
    venus:  { a:[0.72333566, 0.00000390], e:[0.00677672,-0.00004107], i:[3.39467605,-0.00078890],
              L:[181.97909950,58517.81538729], w:[131.60246718, 0.00268329], O:[76.67984255,-0.27769418] },
    dunya:  { a:[1.00000261, 0.00000562], e:[0.01671123,-0.00004392], i:[-0.00001531,-0.01294668],
              L:[100.46457166,35999.37244981], w:[102.93768193, 0.32327364], O:[0.0, 0.0] },
    mars:   { a:[1.52371034, 0.00001847], e:[0.09339410, 0.00007882], i:[1.84969142,-0.00813131],
              L:[-4.55343205,19140.30268499], w:[-23.94362959, 0.44441088], O:[49.55953891,-0.29257343] },
    jupiter:{ a:[5.20288700,-0.00011607], e:[0.04838624,-0.00013253], i:[1.30439695,-0.00183714],
              L:[34.39644051,3034.74612775], w:[14.72847983, 0.21252668], O:[100.47390909, 0.20469106] },
    saturn: { a:[9.53667594,-0.00125060], e:[0.05386179,-0.00050991], i:[2.48599187, 0.00193609],
              L:[49.95424423,1222.49362201], w:[92.59887831,-0.41897216], O:[113.66242448,-0.28867794] }
  };

  function keplerXYZ(p, T) {
    var a = p.a[0] + p.a[1] * T,
        e = p.e[0] + p.e[1] * T,
        I = p.i[0] + p.i[1] * T,
        L = p.L[0] + p.L[1] * T,
        w = p.w[0] + p.w[1] * T,
        O = p.O[0] + p.O[1] * T;
    var argP = w - O;                 // perihelyon argümanı
    var M = norm(L - w);
    if (M > 180) M -= 360;
    /* Kepler denklemi: E - e·sinE = M  (Newton) */
    var E = M + (e * R2D) * sin(M);
    for (var k = 0; k < 12; k++) {
      var dM = M - (E - (e * R2D) * sin(E));
      var dE = dM / (1 - e * cos(E));
      E += dE;
      if (Math.abs(dE) < 1e-9) break;
    }
    /* yörünge düzleminde konum */
    var xv = a * (cos(E) - e);
    var yv = a * Math.sqrt(1 - e * e) * sin(E);
    /* ekliptiğe döndür */
    var xh = xv * (cos(O) * cos(argP) - sin(O) * sin(argP) * cos(I))
           - yv * (cos(O) * sin(argP) + sin(O) * cos(argP) * cos(I));
    var yh = xv * (sin(O) * cos(argP) + cos(O) * sin(argP) * cos(I))
           - yv * (sin(O) * sin(argP) - cos(O) * cos(argP) * cos(I));
    var zh = xv * (sin(argP) * sin(I)) + yv * (cos(argP) * sin(I));
    return { x: xh, y: yh, z: zh };
  }

  function gezegenBoylam(ad, T) {
    var p = keplerXYZ(GEZ[ad], T);
    var d = keplerXYZ(GEZ.dunya, T);
    var x = p.x - d.x, y = p.y - d.y;           // geosentrik
    return norm(Math.atan2(y, x) * R2D);
  }

  /* ---------------------------------------------- Yıldız zamanı & Yükselen */
  function gmst(jd) {
    var T = (jd - 2451545.0) / 36525;
    var g = 280.46061837 + 360.98564736629 * (jd - 2451545.0)
          + 0.000387933 * T * T - T * T * T / 38710000;
    return norm(g);
  }

  function yukselen(lst, enlem, egim) {
    /* ASC = atan2( cos(LST) , -(sin(LST)·cos ε + tan φ · sin ε) ) */
    var y = cos(lst);
    var x = -(sin(lst) * cos(egim) + tan(enlem) * sin(egim));
    var a = norm(Math.atan2(y, x) * R2D);
    return a;
  }

  function mc(lst, egim) {
    var a = norm(Math.atan2(sin(lst), cos(lst) * cos(egim)) * R2D);
    return a;
  }

  /* ---------------------------------------------- ana hesap */
  var BURC = ['Koç','Boğa','İkizler','Yengeç','Aslan','Başak',
              'Terazi','Akrep','Yay','Oğlak','Kova','Balık'];

  function burcAdi(boylam) { return BURC[Math.floor(norm(boylam) / 30)]; }
  function burcNo(boylam)  { return Math.floor(norm(boylam) / 30); }
  function derece(boylam)  { return norm(boylam) % 30; }

  /**
   * @param {number} yil, ay(1-12), gun
   * @param {number} saat, dakika  — YEREL saat
   * @param {number} tzSaat        — yerel saatin UTC farkı (TR: +3)
   * @param {number} enlem, boylam — ondalık derece (kuzey +, doğu +)
   */
  function harita(yil, ayNo, gun, saat, dakika, tzSaat, enlem, boylamYer) {
    var utSaat = saat + dakika / 60 - tzSaat;
    var jd = julianDay(yil, ayNo, gun, utSaat);
    var T = (jd - 2451545.0) / 36525;
    var egim = 23.439291 - 0.0130042 * T;       // ekliptik eğimi

    var konum = {
      gunes:   gunes(T),
      ay:      ay(T),
      merkur:  gezegenBoylam('merkur', T),
      venus:   gezegenBoylam('venus', T),
      mars:    gezegenBoylam('mars', T),
      jupiter: gezegenBoylam('jupiter', T),
      saturn:  gezegenBoylam('saturn', T)
    };

    var lst = norm(gmst(jd) + boylamYer);
    var asc = yukselen(lst, enlem, egim);
    var mcDer = mc(lst, egim);

    /* Whole Sign evleri: yükselenin burcu 1. evdir (en eski ve en sağlam sistem) */
    var evBas = burcNo(asc);
    function evNo(boylam) {
      var b = burcNo(boylam);
      return ((b - evBas) % 12 + 12) % 12 + 1;
    }

    var sonuc = { jd: jd, lst: lst, egim: egim, yukselen: asc, mc: mcDer, gezegenler: {} };
    Object.keys(konum).forEach(function (k) {
      var b = konum[k];
      sonuc.gezegenler[k] = { boylam: b, burc: burcAdi(b), burcNo: burcNo(b),
                              derece: derece(b), ev: evNo(b) };
    });
    sonuc.yukselenBurc = burcAdi(asc);
    sonuc.yukselenBurcNo = burcNo(asc);
    sonuc.yukselenDerece = derece(asc);
    sonuc.mcBurc = burcAdi(mcDer);
    return sonuc;
  }

  global.ODTAstro = {
    harita: harita, julianDay: julianDay, gunes: gunes, ay: ay,
    gezegenBoylam: gezegenBoylam, gmst: gmst, yukselen: yukselen,
    burcAdi: burcAdi, burcNo: burcNo, derece: derece, BURC: BURC, norm: norm
  };
})(typeof window !== 'undefined' ? window : globalThis);
